import { CardFooter } from "reactstrap";
import { H6, LI, P, UL } from "../../../../AbstractElements";
import { activeCoursesAverage } from "../../../../Constant";

const TotalEarningCardFooter = ({ coursePresentStats }) => {
  return (
    <CardFooter>
      <div className="d-flex align-items-center justify-content-center">
        <H6>{coursePresentStats.length ? activeCoursesAverage : "No attendance for active courses."}</H6>
      </div>
      <UL attrUL={{ className: "d-sm-flex d-block simple-list flex-row " }}>
        {coursePresentStats?.map((course, index) => {
          return (
            <LI key={index}>
              <P attrPara={{ className: "f-w-600 font-primary f-12" }}>
              {`${course.courseName}`}
              </P>
              <span className="f-w-700">{course?.percentage}%</span>
            </LI>
          )
        })}
      </UL>
    </CardFooter>
  );
};

export default TotalEarningCardFooter;